import { getSinglePropertyByAddressFromElasticSearch, getSinglePropertyFromElasticSearch } from './searchElastic';
import { Property } from '../../interfaces/interfaces';
import { normalizeGeoPoint } from '../../utilities/util';

/**
 * Custom React Hook - Puts Elastic Search results into recoil state
 *   - Get Geocode data from Google Places API
 *   - Get Elastic Search results of properties
 * @param autoCompleteSelection  (result when user clicks a selection in the location autocomplete dropdown)
 * @returns boolean of success --> array of properties from Elastic Search Server goes into Recoil State
 */
export function useGetProperties() {

	async function fetchPropertyCenterPointByMlsId(mlsId: string) {
		if (!mlsId) {
			console.error('Indeterminate Property for MlsId: Cannot Proceed. (CHP)');
			return null;
		}

		try {
			const property = await getSinglePropertyFromElasticSearch('', mlsId);

			const centerPoint = normalizeGeoPoint(property.location);

			return centerPoint;

		} catch (error) {
			console.error('Problem fetching property data for Mls Id. (CHP)', error);
		}
	}

	async function fetchSingleProperty(propertyId: string): Promise<Property | null> {
		!propertyId && console.error('Indeterminate Property: Cannot Proceed. (CHP)');

		// TODO: Make sure userLocation contains the search type geopoint vs term vs bounds vs polygon
		return await getSinglePropertyFromElasticSearch(propertyId)
			.then((dataFromES: any) => {
				return dataFromES;
			})
			.catch((error: any) => {
				console.error('Problem fetching property data. (CHP)', error);
				return null;
			});
	}

	return [fetchSingleProperty, fetchPropertyCenterPointByMlsId] as const;
}

export const fetchSinglePropertyViaAddress = async (urlAddress: string) => {
	!urlAddress && console.error('Indeterminate Property: Cannot Proceed. (CHP)');
	return await getSinglePropertyByAddressFromElasticSearch(urlAddress)
		.then((dataFromES: any) => {
			return dataFromES;
		})
		.catch((error: any) => {
			console.error('Problem fetching property data. (CHP)', error);
			return null;
		});
};
